import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

import theme from './theme';

/**
 * Emotion style classes
 */
const titleColor = css`
  color: ${theme.color.primary} !important;
`;

const sectionBkg = css`
  background: linear-gradient(to bottom, white, ${theme.color.secondary});
`;

/**
 * Components
 */
const Section = ({ title, children }) => (
  <section className={`section ${sectionBkg}`}>
    <div className="container">
      <h2 className={`title ${theme.triangle} ${titleColor}`}>{title}</h2>
      {children}
    </div>
  </section>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Section;
